import {Routes} from "@angular/router";
import {SensorsModuleComponent} from "./sensors-module.component";
import {SensorsAuthorizedGuard} from "./guards/sensors-authorized.guard";
import {SensorDashboardViewComponent} from "./views/sensor-dashboard-view/sensor-dashboard-view.component";
import {SensorListViewComponent} from "./views/sensor-list-view/sensor-list-view.component";
import {SensorDetailsComponent} from "./views/sensor-details/sensor-details.component";

export const sensorsRoutes: Routes = [
  {
    path: 'sensoren',
    component: SensorsModuleComponent,
    canActivate: [SensorsAuthorizedGuard],
    children: [
      {
        path: '',
        canActivateChild: [SensorsAuthorizedGuard],
        children: [
          {
            path: 'dashboard',
            component: SensorDashboardViewComponent
          },
          {
            path: 'auswertung/:sensorCuid',
            component: SensorDetailsComponent
          },
          {
            path: 'liste',
            component: SensorListViewComponent
          },
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
          },
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/sensors/sensors-routing.ts